declare var swal: any;

import { Component, ViewChild, OnInit, Input } from '@angular/core';
import { CommandsService } from '../services/commands.service';
import { LanguageService } from '../services/language.service';
import { TurtleService } from '../services/turtle.service';
import { CanvasService } from '../services/canvas.service';
import { EditorContentService } from '../services/editorcontent.service';
import { DebuggerService } from '../services/debugger.service';
import { ThrowErrorListener } from '../interpreter/ThrowErrorListener';

import { AppComponent } from './app.component';
import { HistoryComponent } from './history.component';
import { CanvasComponent } from './canvas.component';
import { HeaderComponent } from './header.component';
import { SessionStorageService } from '../services/sessionstorage.service';
import { BlocksComponent } from './blocks.component';
import { BlocksService } from '../services/blocks.service';
import { BluetoothService } from '../services/bluetooth.service';

declare var require: (...any) => any;
declare var ace: any;

@Component({
	selector: 'app-input',
	templateUrl: './input.component.html',
	providers: [LanguageService, CommandsService, TurtleService, EditorContentService, SessionStorageService, BlocksService, BluetoothService]
})

export class InputComponent implements OnInit {

	@Input('languageServiceMaster') lang: LanguageService;
	@Input('commandsServiceMaster') commandsService: CommandsService;
	@Input('turtleServiceMaster') turtleService: CommandsService;
	@Input('canvasServiceMaster') canvasService: CanvasService;
	@Input('editorContentServiceMaster') et: EditorContentService;
	@Input('sessionstorageMaster') sessionstorage: SessionStorageService;
	@Input('blocksServiceMaster') blocks: BlocksService;
	@Input('bluetoothServiceMaster') bs: BluetoothService;

	@ViewChild('canvasID') canvasComponent;

	// execution speed, integer in range 0..10
	private speedFromChild: number;

	// variables related to Editor
	private editor = new Array();
	private errorIndizes = [];
	private hooks = new Array();
	static updateTurtleSpeed = function (speed: number) { };
	//private variables = new Array();

	// Variables for the interpreter
	private antlr4;
	private LogoLexer;
	private LogoEditorLexer;
	private LogoParser;
	private LogoEditorParser;
	private LogoVisitor;
	private LogoEditorVisitor;

	// Whether a visitor is currently executing
	private isVisitorRunning: boolean = false;
	// The newest visitor that is currently running (or has been running)
	private latestRunningVisitor;
	static stopVisitor = function () { };

	// Used for debug mode
	private debugger;
	static stepForward = function () { };
	static stepBackward = function () { };
	// TODO: the whole thing with the highlighting is not solved very elegantly

	// Used to determine whether editor contains syntactical errors
	private hasErrors;

	//Damlev distance used to determine distance between two strings
	static damlev_distance;

	//Logging
	private text = "";
	private start = "";
	private userName: string;
	private USERNAMELENGTH = 10;
	private startProgTime = "";
	private containsBugs = false;
	private damlev;

	//highlighting errors in Editor
	private tok;
	static markers = [];

	//static object
	static inputComponent;

	constructor() {
		InputComponent.inputComponent = this;

		// load modules required for interpreter
		this.antlr4 = require('antlr4/index.js');
		this.LogoLexer = require('../interpreter/interpreter-input/LogoLexer.js');
		this.LogoParser = require('../interpreter/interpreter-input/LogoParser.js');
		this.LogoVisitor = require('../interpreter/interpreter-input/LogoVisitor.js');
		this.LogoEditorLexer = require('../interpreter/interpreter-editor/LogoEditorLexer.js');
		this.LogoEditorParser = require('../interpreter/interpreter-editor/LogoEditorParser.js');
		this.LogoEditorVisitor = require('../interpreter/interpreter-editor/LogoEditorVisitor.js');

		//load and instatiate damlev distance library
		var ld = require("../../../node_modules/levenshtein-damerau/skodld.js");
		InputComponent.damlev_distance = ld;

		//collect data for experiments
		if (AppComponent.LOGGING) {
			//create random string as username for logging
			this.userName = this.createUsername(this.USERNAMELENGTH);

			//create new folder for this user is digitaltag
			var http = new XMLHttpRequest();
			var url = "https://api.dropboxapi.com/2/files/create_folder_v2";
			var params = "{\"path\": \"/debugger/" + this.userName + "\",\"autorename\": false}";
			http.open("POST", url, true);

			//Send the proper header information along with the request
			http.setRequestHeader("Content-Type", "application/json");
			http.setRequestHeader("Authorization", "Bearer 5KTo_nIkyVAAAAAAAAAAC0aIxYhCD_e9ZJE5Q_Phm2937fbJzP6L-cjhrH16awjm");

			http.onreadystatechange = function () {//Call a function when the state changes.
				/*
					if(http.readyState == 4 && http.status == 200) {
							alert(http.responseText);
					}
				 */
			}
			http.send(params);

			this.start = this.returnCurrentTime();
		}

	}

	disableEditor() {
		//diable editor: text cannot be changed and opacity is slightly see-through
		AppComponent.editor.setOptions({
			readOnly: true,
			highlightActiveLine: false,
			highlightGutterLine: false
		});
		AppComponent.editor.container.style.opacity = 0.75
	}

	enableEditor() {
		//enable editor: text can be changed and it is not see-through any longer
		AppComponent.editor.setOptions({
			readOnly: false,
			highlightActiveLine: true,
			highlightGutterLine: true
		});
		AppComponent.editor.container.style.opacity = 1;
	}

	returnCurrentTime(): string {
		var currentdate = new Date();
		var h = currentdate.getHours() + "";
		var m = currentdate.getMinutes() + "";
		var s = currentdate.getSeconds() + "";

		var datetime = currentdate.getDate() + "/"
			+ (currentdate.getMonth() + 1) + "/"
			+ currentdate.getFullYear() + " @ "
			+ (h.length > 1 ? h : "0" + h) + ":"
			+ (m.length > 1 ? m : "0" + m) + ":"
			+ (s.length > 1 ? s : "0" + s);
		return datetime;
	}

	setCodingTime() {
		if (this.startProgTime === "") {
			this.startProgTime = this.returnCurrentTime();
		}
	}

	createUsername(length: number): string {
		var text = "";
		var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

		for (var i = 0; i < length; i++)
			text += possible.charAt(Math.floor(Math.random() * possible.length));

		return text;
	}

	//MARTINA BRACKET FIX
	extractExtraneous(extraneous): any {
		var index = 0;
		for (var i = extraneous.length - 1; i >= 0; i--) {
			if ((extraneous.charAt(i) == '[') || (extraneous.charAt(i) == ']')) {
				if (i < extraneous.length - 1) {
					index = i + 1;
				} else {
					index = i;
				}
			}
		}
		return extraneous.substr(index);
	}

	ngOnInit() {
		// Instantiate debugger
		this.debugger = new DebuggerService(this.et, this.canvasComponent, this.commandsService, this.lang);

		// Set up input line as one-line ace editor
		this.commandsService.setLangService(this.lang);
		this.commandsService.initInputLine(this.addElem.bind(this));

		//reference to current this object, because we lose in callback we lose the this and all of its variables
		var cur = this;

		//disable editor
		cur.disableEditor();

		//set headline text to "initialize"
		this.setHeadLineTextTo(this.lang.getLang()["init"], "#FFFFFF");

		//register eventlistener for editor change
		AppComponent.editor.on("change", function (e) {
			//read in content of editor
			var text = AppComponent.editor.getValue().toLowerCase();
			clearTimeout(cur.speedFromChild);

			(<any>cur).speedFromChild = setTimeout(function () {
				//For testing:
				//console.time("totalImCallback");

				cur.editor = new Array();
				cur.errorIndizes = new Array();

				//param: parameters for method with index "offset". edit: method with index "offset"
				var offset = 0;
				var edit = [];
				var param = [];

				//remove all markers from current module
				var keys = Object.keys(InputComponent.markers);
				for (var key of keys) {
					var marker = InputComponent.markers[key];
					AppComponent.editor.session.removeMarker(marker);
					InputComponent.markers[i] = null;
				}

				//prepare for checking: Soon we'll collect errors in Editor and methods seen therein
				var methodCallArray = [];
				var errors = [];

				//initially no errors found
				cur.hasErrors = false;

				//remove EOLs at the beginning of the text and increment offset
				while (text.startsWith("\r\n") || text.startsWith("\n")) {
					if (text.startsWith("\r\n")) {
						text = text.substr(2);
						offset = offset + 1;
					} else {
						text = text.substr(1);
						offset = offset + 1;
					}
				}

				//remove comments
				var textParts = text.split("\n");
				var i;
				for (i = 0; i < textParts.length; i++) {
					textParts[i] = textParts[i].split("#")[0];
				}
				text = textParts.join("\n");

				//check for special characters, that are not permitted in code
				var containsSpecialCharacters = /[äöüÄÖÜßéÉèÈêÊ^$£¨{}§°çÇ%&'?`àá´À;@~ñÑ‰¦¬Øøë€¢,\\]/.test(text);
				if (containsSpecialCharacters) {
					cur.hasErrors = true;

					//find location (i.e. line) of first special character
					let specialCharacterText = text.split(/[äöüÄÖÜßéÉèÈêÊ^$£¨{}§°çÇ%&'?`àá´À;@~ñÑ‰¦¬Øøë€¢,\\]/);
					specialCharacterText = specialCharacterText[0];
					let numberOfNewlines = specialCharacterText.split(/\n/).length - 1;

					//find type of special character
					let specialCharacter = text.substr(specialCharacterText.length, 1);

					//push to errors to be shown
					cur.errorIndizes.push({ row: numberOfNewlines + offset, col: 0, start: 0, stop: 100, text: cur.lang.translateKey("specialCharacters") + specialCharacter, type: "error" });

				} else {
					//no special characters found; continue with reading editor
					cur.editor = cur.readEditor(text, offset);

					if (!(cur.editor == null)) {
						var errorsToDisplay = cur.getErrorArray(cur.editor);

						if (errorsToDisplay.length > 0) {
							//for each error get the right error message and add these errors to the error indizes
							cur.addErrorsToErrorIndizes(cur, errorsToDisplay, text, 0);
						}
					}

				}

				if (cur.hasErrors || !cur.doCheckMethodCalls(cur.editor)) {
					//don't check for method calls
				} else {
					//check for method calls
					var errorArray = cur.checkMethodCalls(cur.editor, cur);
					//if there are any errors in the errorArray, add them to the errorIndizes
					if (errorArray.length > 0) {
						cur.errorIndizes.push.apply(cur.errorIndizes, errorArray);
					}
				}

				AppComponent.editor.session.clearAnnotations();
				AppComponent.editor.session.setAnnotations(cur.errorIndizes);
				//Range(row from, column from, row to, colum to)

				//store editor text in localstorage for next session
				cur.sessionstorage.storeEditorContent(AppComponent.editor.getValue())//TODO: Hilfe von Renato? Speichere alle Tabs ab! cur.et.prepareEditorTabContentForSaving());

			}, 2000);

		}).bind(this);

		//ugly hack for first syntax check, which takes much longer: start on startup...
		setTimeout(function () {
			this.initializeParser();
		}.bind(this), 1000);

	}

	initializeParser() {
		//load speedRange and editorContent from last session from localstorage, TODO: retrieve text for multiple tabs
		this.sessionstorage.retrieveSpeed();
		this.sessionstorage.retrieveEditorContent();

		this.executeCommand('pu fd 0 pd cs', null, false);
	}

	//counts brackets and checks whether there are the same number of opening and closing brackets
	//returns true iff there is a problem with the number of brackets
	checkSquareBracketNumber(text): boolean {
		let countOpeningSquareBrackets = text.split("[").length;
		let countClosingSquareBrackets = text.split("]").length;
		return (countOpeningSquareBrackets !== countClosingSquareBrackets);
	}

	//counts brackets and checks whether there are the same number of opening and closing brackets
	//returns true iff there is a problem with the number of brackets
	checkRoundBracketNumber(text): boolean {
		let countOpeningRoundBrackets = text.split("(").length;
		let countClosingRoundBrackets = text.split(")").length;
		return (countOpeningRoundBrackets !== countClosingRoundBrackets);
	}

	//finds out if we can check method calls (return values: true: we should check method calls, false: we should not check them)
	doCheckMethodCalls(editor): boolean {
		return editor.doCheckMethodCalls;
	}

	//adds the errors from "errorsToAdd" to errorindizes (t: current method text, off: method offset)
	addErrorsToErrorIndizes(c, errorsToAdd, t, off) {
		for (let error of errorsToAdd) {
			c.handleError(error, t);
			c.errorIndizes.push({ row: off + error.line, col: 0, start: 0, stop: 100, text: error.msg, type: "error" });
		}
	}

	//returns "errors" array from LogoEditorVisitor
	getErrorArray(ourEditor): Array<Object> {
		var returnArray = ourEditor.errors;
		return returnArray;
	}

	//returns all the text that's in the context, in order to be able to display later what the user wrote too much
	getTooMuch(ctx): String {
		//get children text
		var text = ctx.constructor.toString().substr(9, 8);
		if (text !== "Terminal") {
			var temp = "";
			for (var i = 0; i < ctx.children.length; i++) {
				temp = temp + this.getTooMuch(ctx.children[i]);
			}
			return temp;
		} else {
			return ctx.getText() + " ";
		}
	}

	// checks all the method calls in the methods for method not found, misspelled end etc.
	// returns array of errors to display
	checkMethodCalls(ourEditor, c): Array<Object> {

		// here we collect all the errors of methodcalls
		var arrayOfErrors = new Array();

		// get the names of all the defined methods in an array
		//var methodNames = Object.keys(ourEditor.methodCallArray);
		var methods = Object.keys(ourEditor.methodCallArray);

		// get the method names that exist
		var methodNames = new Array();
		methodNames = Object.keys(ourEditor.param);


		// for each method, check the method calls for method not found
		//BEFORE:for (var i = 0; i<methodNames.length; i++){
		for (let method of methods) {

			var methodCallsOfThisMethod = ourEditor.methodCallArray[method];

			//if there are no method calls in that method, continue to the next method
			if (methodCallsOfThisMethod == null) {
				continue;
			}
			// get the number of method calls in that method
			var numberOfMethodCallsOfThisMethod = Object.keys(methodCallsOfThisMethod).length;

			// check if the functions they're calling were defined
			for (var j = 0; j < numberOfMethodCallsOfThisMethod; j++) {
				// get name of the method we're trying to call
				var methodName = methodCallsOfThisMethod[j].procedureInvocation.children[0].getText();
				var lineOfMethodCall = methodCallsOfThisMethod[j].line;
				var methodParams = ourEditor.param[methodName];

				//we need to check for misspelled end
				if (j === numberOfMethodCallsOfThisMethod - 1) {

					if (methodCallsOfThisMethod[j].maybeMisspelledMake) {
						if (methodParams == null) {
							//the function doesn't exist
							arrayOfErrors.push({ row: lineOfMethodCall, col: 0, start: 0, stop: 100, text: this.lang.translateKey("didYouMean") + "make", type: "error" });
							if (ourEditor.maybeEnd[method]) {
								//missing end
								arrayOfErrors.push({ row: lineOfMethodCall, col: 0, start: 0, stop: 100, text: this.lang.translateKey("missingEnd"), type: "error" });
							}
							break;
						} else {
							//the method exists
							arrayOfErrors.push({ row: lineOfMethodCall, col: 0, start: 0, stop: 100, text: this.lang.translateKey("derefMake"), type: "error" });
							if (ourEditor.maybeEnd[method]) {
								//missing end
								arrayOfErrors.push({ row: lineOfMethodCall, col: 0, start: 0, stop: 100, text: this.lang.translateKey("missingEnd"), type: "error" });
							}
						}
					}
					else if (ourEditor.maybeEnd[method]) {
						if (methodParams == null) {
							// the method doesn't exist,so we check the damlev distance to 'end'

							var longer;
							var shorter;

							//get the damerau-levenshtein distance
							if (methodName.length > 3) {
								longer = methodName;
								shorter = "end";
							} else {
								longer = "end";
								shorter = methodName;
							}
							var damlevDistance = InputComponent.damlev_distance(longer, shorter);
							if (damlevDistance <= 1) {
								//it's close enough to 'end', so the 'end' was misspelled
								arrayOfErrors.push({ row: lineOfMethodCall, col: 0, start: 0, stop: 100, text: this.lang.translateKey("misspelledEnd"), type: "error" });
								break;
							} else {
								//it's not close enough to 'end', so the 'end' is missing
								arrayOfErrors.push({ row: lineOfMethodCall, col: 0, start: 0, stop: 100, text: this.lang.translateKey("missingEnd"), type: "error" });
							}
						} else {
							//the method called exists so there was no misspelled 'end'
							arrayOfErrors.push({ row: lineOfMethodCall, col: 0, start: 0, stop: 100, text: this.lang.translateKey("missingEnd"), type: "error" });
						}
					}
				}

				//was there a parameter with "? and it's similar to make? --> check if the method exists or it's a misspelled make
				if (methodCallsOfThisMethod[j].maybeMisspelledMake) {
					if (methodParams != null) {
						// the method exists, it was not a 'make'
						arrayOfErrors.push({ row: lineOfMethodCall, col: 0, start: 0, stop: 100, text: this.lang.translateKey("derefMake"), type: "error" });
					} else {
						// the method doesn't exist, maybe the user meant 'make'
						arrayOfErrors.push({ row: lineOfMethodCall, col: 0, start: 0, stop: 100, text: this.lang.translateKey("didYouMean") + "make", type: "error" });
						continue;
					}
				}

				if (methodParams == null) {
					// the method was not defined

					// add an error to the errorArray
					arrayOfErrors.push({ row: lineOfMethodCall, col: 0, start: 0, stop: 100, text: this.lang.translateKey("nosuchmethod") + methodName, type: "error" });

					// check if they meant something else
					//List of functions: = ["abs","acos","arccos","asin","arcsin","atan","arctan","cos","sin","sqrt","tan","random","rnd","ran","mod","power","log"]
					let listOfCommands = ["back", "bk", "backward", "circle", "cs", "clearscreen", "ct", "fd", "forward", "hideturtle", "home", "ht", "if", "left", "lt", "make", "pd", "pe", "pendown", "penerase", "penpaint", "penup", "ppt", "pr", "print", "pu", "repeat", "right", "rt", "setheading", "setpencolor", "setsc", "setscreencolor", "setpc", "setpenwidth", "setpw", "setx", "sety", "setxy", "showturtle", "st", "stop", "stopall", "wait", "wash", "while"];
					let listOfFunctions = ['random', 'rnd', 'cos', 'arccos', 'acos', 'sin', 'arcsin', 'asin', 'tan', 'arctan', 'atan', 'sqrt', 'log', 'power', 'mod', 'abs']
					let listOfParams = methodCallsOfThisMethod[j].definedVariables;

					listOfCommands.push.apply(listOfCommands, listOfFunctions);
					listOfCommands.push.apply(listOfCommands, methodNames);
					//listOfCommands.push.apply(listOfCommands,listOfParams);

					var longer;
					var shorter;
					for (let cmd of listOfCommands) {
						//test whether space is missing, like in fd100
						if (methodName.startsWith(cmd)) {
							var secondPart = methodName.substr(cmd.length);
							if (isNaN(secondPart)) {
								// the second part is not a number, so no suggestion should be displayed
							} else {
								// the second part is a number, so we can make a suggestion of what they might have meant
								arrayOfErrors.push({ row: lineOfMethodCall, col: 0, start: 0, stop: 100, text: this.lang.translateKey("didYouMean") + cmd + " " + secondPart });
							}
						}

						//get the damerau-levenshtein distance
						if (methodName.length > cmd.length) {
							longer = methodName;
							shorter = cmd;
						} else {
							longer = cmd;
							shorter = methodName;
						}
						var damlevDistance = InputComponent.damlev_distance(longer, shorter);
						//MARTINA TODO: find a good value
						if (damlevDistance <= cmd.length / 2) {
							arrayOfErrors.push({ row: lineOfMethodCall, col: 0, start: 0, stop: 100, text: this.lang.translateKey("didYouMean") + cmd, type: "error" });
						}
					}

					//Schauen, ob es einen Parameter gibt mit diesem Namen
					for (let par of listOfParams) {
						if (methodName === par) {
							arrayOfErrors.push({ row: lineOfMethodCall, col: 0, start: 0, stop: 100, text: this.lang.translateKey("didYouMean") + ":" + par, type: "error" });
						}
					}
					continue;
				}

				// there exists a method with that methodname. now we will check if there are the right number of arguments
				var numberOfArgumentsInProcedureCall = methodCallsOfThisMethod[j].procedureInvocation.children.length - 1;
				var requiredNumberOfArgumentsForMethod = methodParams.length;

				if (numberOfArgumentsInProcedureCall > requiredNumberOfArgumentsForMethod) {
					// there are too many arguments
					arrayOfErrors.push({ row: lineOfMethodCall, col: 0, start: 0, stop: 100, text: this.lang.translateKey("procCallTooManyArgs") + methodName, type: "error" });

					//find out what is too much
					var tooMuch = "";
					for (var i = requiredNumberOfArgumentsForMethod + 1; i < methodCallsOfThisMethod[j].procedureInvocation.children.length; i++) {
						tooMuch = tooMuch + this.getTooMuch(methodCallsOfThisMethod[j].procedureInvocation.children[i]);
					}

					arrayOfErrors.push({ row: lineOfMethodCall, col: 0, start: 0, stop: 100, text: this.lang.translateKey("tooMuch") + tooMuch, type: "error" });

				} else if (numberOfArgumentsInProcedureCall < requiredNumberOfArgumentsForMethod) {
					// there are not enough arguments
					arrayOfErrors.push({ row: lineOfMethodCall, col: 0, start: 0, stop: 100, text: this.lang.translateKey("procCallNotEnoughArgs") + methodName, type: "error" });
				}
			}
		}

		return arrayOfErrors;
	}

	// the the current text element to the CommandService, which is bound to the HistoryComponent and will thus annotate the command there
	// if there is no error in the command itself
	addElem(newElem: string) {
		if (newElem) {
			/*
			let errorcode = this.executeCommand(newElem.toLowerCase());
			if (errorcode === 0) {
				this.commandsService.commands.push(newElem);
			}
			*/
			this.executeCommand(newElem.toLowerCase(), null, true);

			if (AppComponent.LOGGING) {
				//create file on cs enter hit
				if (newElem.match(/cs/i) || newElem.match(/next/i)) {
					var http = new XMLHttpRequest();
					var url = "https://content.dropboxapi.com/2/files/upload";
					http.open("POST", url, true);

					//Send the proper header information along with the request
					http.setRequestHeader("Content-Type", "application/octet-stream");
					http.setRequestHeader("Authorization", "Bearer 5KTo_nIkyVAAAAAAAAAAC0aIxYhCD_e9ZJE5Q_Phm2937fbJzP6L-cjhrH16awjm");
					http.setRequestHeader("Dropbox-API-Arg", "{\"path\":\"/" + AppComponent.STORAGELOCATION + "/" + this.userName + "/A.txt\", \"mode\":{\".tag\":\"add\"}, \"autorename\":true }");

					/*
					http.onreadystatechange = function() {//Call a function when the state changes.
							if(http.readyState == 4 && http.status == 200) {
								//alert(http.responseText);
							}
					}
					 */

					http.send(this.text + " \n\r ---" + "Unknown" + " \n\r ---" + "Containing Syntax Errors: " + this.containsBugs + " \n\r ---" + " Editor: \n\r" + AppComponent.editor.getValue().toLowerCase() + "\n\r --- " + "Started:" + this.start + "\n\r --- " + "Started Programming: " + this.startProgTime + "\n\r --- " + "Finished: " + this.returnCurrentTime());
					this.text = "";
					this.containsBugs = false;
					//CanvasComponent.startTime = this.returnCurrentTime();
					this.start = this.returnCurrentTime();
					this.startProgTime = "";
				} else {
					this.text = this.text + " " + newElem;
				}
			}

		}
	}

	// try to interprete the text written in content
	readEditor(content, offset): Array<string> {
		try {
			//TODO: [ADD] disable editor
			//this.disableEditor();

			//TODO: [ADD] set Headline Text to "checking editor"
			//this.setHeadLineTextTo(this.lang.getLang()['checking'], "#FFFFFF");

			//console.time("readEditorTotal");
			//cut away spaces in front and after the string. No leading spaces any longer
			content = content.trim();

			// count number of spaces in offset. Offset is used to determine the line in which a syntax error occured
			// used in error highlighting
			if (!/^\s/.test(content)) {
				offset--;
			}

			// remove comments from code
			content = content.replace(/^.*#.*$/mg, '');

			// create parsetree for the current editor content and visit it
			let chars = new this.antlr4.InputStream(content.toLowerCase() + '\r\n');
			let lexer = new this.LogoEditorLexer.LogoEditorLexer(chars);
			let tokens = new this.antlr4.CommonTokenStream(lexer);
			this.tok = tokens;

			let parser = new this.LogoEditorParser.LogoEditorParser(tokens);
			parser.addErrorListener(ThrowErrorListener.INSTANCE);
			let tree = parser.prog();
			let visitor = new this.LogoEditorVisitor.LogoEditorVisitor(content, offset);
			var a = visitor.visitProg(tree);
			return a;

		} catch (e) {

			let endCol = this.tok.tokens[e.tokenIndex].column;
			let endLine = this.tok.tokens[e.tokenIndex].line + offset;
			this.hasErrors = true;
			let startLine, startCol;

			//problem when first TO is missing
			//TODO: First line to and end in all cases (missing space, so not shown)
			if (e.tokenIndex > 0) {
				startCol = this.tok.tokens[e.tokenIndex - 1].column;
				startLine = this.tok.tokens[e.tokenIndex - 1].line + offset;
			} else {
				startCol = this.tok.tokens[e.tokenIndex].column;
				startLine = this.tok.tokens[e.tokenIndex].line + offset;
			}

			//handle to and end cases, which would be on wrong line
			//TODO:END still not displayed correctly, wrong line
			if (endCol === 0) {
				endCol = 1;
				startCol = 0;
				startLine++;
				endLine = startCol;
			}

			//TODO: MARKERS SHOULD BE ADDED AGAIN!
			//var Range = (<any>window).ace.require('ace/range').Range;

			//add new marker to ace editor to be displayed
			//var id = AppComponent.editor.session.addMarker(new Range(startLine, startCol, endLine, endCol), "myMarker", "text");

			//add newly added marker to list for removal later on
			//InputComponent.markers[moduleNumber] = id;

			// analyze error according to error message
			let errormessage = this.handleError(e, content);


			//report error to editor, because originating from editor
			this.errorIndizes.push({ row: e.line + offset, text: errormessage, type: 'error' });

			//TODO: [ADD] enable editor
			//this.enableEditor();
		}
	}

	private setHeadLineTextTo(text: string, color: string): void {
		//set new text value and color 
		document.getElementById("headerText").style.color = color;
		document.getElementById("headerText").textContent = text;
	}

	private leaveDebugMode() {
		this.debugger.endSession();
		this.et.hideDebugElements();
	}

	private debugCallback(visitorState) {
		let continueExecution = this.debugger.callback(visitorState);
		console.log('[INPT] Waiting for user input.');
		return continueExecution;
	}

	//check whether input conforms all syntactic requirements with built-in commands, using LogoEditorVisitor
	private syntaxChecking(content: string) {
		let containsSyntaxError = false;
		//Convert commands to methods with random names
		let commandAsMethodText = "to inputCommands" + Math.floor(Math.random() * Math.pow(10, 10)) + "\n" + content + "\n" + "end"
		//run syntax checker on input
		let potentialErrors = this.readEditor(commandAsMethodText, 0);

		if (!(potentialErrors == null)) {//no parse error
			let errors = this.getErrorArray(potentialErrors);

			//test whether errors are related to using program declaration syntax in input field
			for (var i = 0; i < errors.length; i++) {
				if ((<any>errors[i]).msg === "missingEnd" || (<any>errors[i]).msg === "manyEnds" || (<any>errors[i]).msg.startsWith("variableNotDeclared")) {
					errors = [{ line: 2, msg: "definitionInInput" }];
				}
			}

			//read error messages
			if (errors.length > 0) {
				let errormessages = [];
				for (var errorIndex = 0; errorIndex < errors.length; errorIndex++) {
					let message = (errors[errorIndex] as any).msg;
					if (!message.startsWith("tooMuch")) {
						errormessages.push(this.lang.getLang()[message]);
					}
					containsSyntaxError = true;
				}

				//report errors
				this.commandsService.addErrorMessage(errormessages, this.lang.getLang()["input"] + content);

				//enable editor
				this.enableEditor();

				return true;
			}
		} else {//parse error
			//report errors to history including user input
			this.commandsService.addErrorMessage([this.errorIndizes[0].text], this.lang.getLang()["input"] + content);
			//remove all errors from this session...
			this.errorIndizes = [];
			return true;
		}

		return containsSyntaxError;
	}

	//set Editor Content to text programmatically, used to create testcases and solutions for Klett
	setEditorText(text) {
		AppComponent.editor.setValue(text, 1);
	}

	// execute the text in content (used to execute code originating from input field)
	// set editorContentGiven to true if you don't want it to check the editor (while testing exercises from our course book)
	executeCommand(content, editorContent, addToHistory): number {
		CanvasComponent.stop = false;

		//TODO: A nicer solution to this problem would be to keep whitespace in the LEXER or write them to hidden channel
		//checke wether whitespace are correct in input
		var whitespaceIncorrect = /\d[fd|forward|bk|back|backward|rt|right|lt|left]/.test(content);
		if(whitespaceIncorrect){
			this.commandsService.addErrorMessage([this.lang.getLang()["whitespace"]], this.lang.getLang()["input"] + content);

			// inform user in history field about the kind of error
			this.commandsService.addCommand(content);
			return 1;
		}

		//-- perform syntax checking on user input
		//1. check for special characters
		var containsSpecialCharacters = /[äöüÄÖÜßéÉèÈêÊ^$£¨{}§°çÇ%&'?`àá´À;@~ñÑ‰¦¬Øøë€¢,\\]/.test(content);
		if (containsSpecialCharacters) {
			//find location (i.e. line) of first special character
			let specialCharacterText = content.split(/[äöüÄÖÜßéÉèÈêÊ^$£¨{}§°çÇ%&'?`àá´À;@~ñÑ‰¦¬Øøë€¢,\\]/);
			specialCharacterText = specialCharacterText[0];
			let numberOfNewlines = specialCharacterText.split(/\n/).length - 1;
			//find type of special character
			let specialCharacter = content.substr(specialCharacterText.length, 1);
			let res = [];
			this.commandsService.addErrorMessage([this.lang.translateKey("specialCharacters") + specialCharacter], this.lang.getLang()["input"] + content);
			this.commandsService.addCommand(content);

			//enable editor
			this.enableEditor();

			return 1;
		}

		//2. check and report syntactical errors from predefined error list in LogoEditor Grammar
		let containsSyntaxError = this.syntaxChecking(content);
		if (containsSyntaxError) {
			this.commandsService.addCommand(content);

			//enable editor
			this.enableEditor();

			return 1;
		}

		//check whether input contains a method calld to user defined method
		let caracters = new this.antlr4.InputStream(content + '\r\n');
		let lex = new this.LogoLexer.LogoLexer(caracters);
		let toks = lex.getAllTokens();
		let containsUserDefinedMethods = false;
		for (let tokenIndex = 0; tokenIndex < toks.length; tokenIndex++) {
			//if Tokey is of Type 106 (see LogoLexer.tokens), it is a String//Methodcall
			if (toks[tokenIndex].type === 110) {
				//TODO: check whether there is a method declaration for this method call in editor
				//TODO: if not: report error, add commands to history and return 1
				containsUserDefinedMethods = true;
				break;
			}
		}

		//if input contains userdefined method: syntax check editor
		if (containsUserDefinedMethods) {
			try {
				this.setHeadLineTextTo(this.lang.getLang()['parsingEditor'], "#FFFFFF");

				if (editorContent === null) {
					//if not testing exercises with given inputs, read content from editor
					this.editor = this.readEditor(AppComponent.editor.getValue(), 0);
				} else {
					//used in unittests
					this.editor = this.readEditor(editorContent, 0);
				}

				// in case there is still an error in editor, inform user, no execution allowed under these circumstances
				if (this.errorIndizes.length > 0) {
					var title = this.lang.getLang()['hoppla'];
					var text = this.lang.getLang()['errorineditor'];
					swal(title, text, 'error')
					this.commandsService.checkPlaceholderText();
					this.setHeadLineTextTo(this.lang.getLang()['XLogoOnline'], this.lang.getLang()['XLogoOnlineColor']);

					//enable editor
					this.enableEditor();

					return 0;
				}

			} catch (e) {
				console.log('strange error. not supposed to happen, check input component!');
				//enable editor
				this.enableEditor();

				return 1;
			}
		}

		//execute commands from input field using LogoVisitor with root node Prog
		try {
			let chars = new this.antlr4.InputStream(content + '\r\n');
			let lexer = new this.LogoLexer.LogoLexer(chars);
			let tokens = new this.antlr4.CommonTokenStream(lexer);

			//if input contains a method calld to user defined method, check editor
			//let temp = lexer.getAllTokens();

			let parser = new this.LogoParser.LogoParser(tokens);
			parser.addErrorListener(ThrowErrorListener.INSTANCE);
			let tree = parser.prog();
			let speed = (9 - parseInt((<HTMLInputElement>document.getElementById('speedRange')).value)) * 100;

			let inDebugMode = this.et.getDebugMode();
			let visitor = new this.LogoVisitor.LogoVisitor(content, speed, this, inDebugMode, this.debugCallback.bind(this), function () {
				this.isVisitorRunning = false;
				this.commandsService.setCommandLineText('');
				this.setHeadLineTextTo(this.lang.getLang()['XLogoOnline'], this.lang.getLang()['XLogoOnlineColor']);

				// Enable UI elements again
				this.commandsService.inputLine.setReadOnly(false);
				(<HTMLButtonElement>document.getElementById('stopExec')).disabled = true;
				this.et.enableButton(this.et.getDebugToggleButton());
				this.et.enableButton(this.et.getDebugToggleSwitch());
				this.enableEditor();

				if (inDebugMode) {
					console.log('[INPT] Got to the end, ending debug execution.')
					this.leaveDebugMode();
				}

				// Set focus on input line after execution
				ace.edit('inputEditor').focus();
			}.bind(this));

			/* Set the static stopVisitor function. This function can be used to terminate the visitor from another component,
			 * even after the executeCommand function (that is, _this_ function) has returned.
			 */
			InputComponent.stopVisitor = function () {
				if (this.isVisitorRunning) {
					this.stopVisitor();
				}
			}.bind(this);

			// Possibly, another visitor is still running (i.e. a long Logo command is still in execution), so we check if that's the case
			if (this.isVisitorRunning && addToHistory) {
				this.stopVisitor();
			} else {
				// in this case, no visitor is running, so we launch this one!
				this.isVisitorRunning = true;
				this.latestRunningVisitor = visitor;

				//set headline text, not done when initializing parser
				if (addToHistory) {
					this.setHeadLineTextTo(this.lang.getLang()['executingVisitor'], "#FFFFFF");
				}

				// Disable UI elements
				this.commandsService.inputLine.setReadOnly(true);
				(<HTMLButtonElement>document.getElementById('stopExec')).disabled = false;
				this.et.disableButton(this.et.getDebugToggleButton());
				this.et.disableButton(this.et.getDebugToggleSwitch());
				this.disableEditor();

				// Show debug elements depending on execution mode
				if (inDebugMode) {
					this.et.showDebugElements();
				}

				// Start executing input
				visitor.visitProg(tree);

				//add to commandService to be shown in History
				if (addToHistory) {
					this.commandsService.addCommand(content);
				}

			}

			// Set the function to be used when user presses the Next button in debug mode
			InputComponent.stepForward = function () {
				console.log('\n[INPT] Next button has been clicked.');
				this.debugger.stepForward(this.latestRunningVisitor);
			}.bind(this);

			InputComponent.stepBackward = function () {
				console.log('\n[INPT] Prev button has been clicked.');
				this.debugger.stepBackward();
			}.bind(this);

			// Updates turtle speed when 
			InputComponent.updateTurtleSpeed = function(speed: number) {
				this.latestRunningVisitor.updateTurtleSpeed(speed);
			}.bind(this);

			return 0;
		} catch (e) {
			//enable editor
			this.enableEditor();

			// analyze error according to error message
			let errormessage = this.handleError(e, content);
			//this.setCommandLineTextTo(errormessage);
			this.commandsService.addErrorMessage([errormessage], this.lang.getLang()["input"] + content);

			// inform user in history field about the kind of error
			//this.commandsService.addString(errormessage);
			this.commandsService.addCommand(content);
			return 1;
		}

	}

	private showProgress(newText: string, color: string): [string, string] {
		//store old text and color
		let oldColor = document.getElementById("headerText").style.color;
		let oldText = document.getElementById("headerText").textContent;

		//set new text value and color 
		document.getElementById("headerText").style.color = color;
		document.getElementById("headerText").textContent = newText;

		//return old textValue and color to restore later on
		return [oldColor, oldText];
	}

	// If a visitor is still running, we ask whether the user would like to stop it.
	private stopVisitor() {
		// The visitor might have terminated by now, so examine it - otherwise the commandLineText will be set erroneously.
		if (this.et.getDebugMode()) {
			this.latestRunningVisitor.stop();
			return;
		} else if (this.isVisitorRunning) {
			this.latestRunningVisitor.stop();
			this.setHeadLineTextTo(this.lang.getLang()['XLogoOnline'], this.lang.getLang()['XLogoOnlineColor']);
		}
	}

	bracketsInMethodOkay(methodText): boolean {
		var squareCount = 0;
		var roundCount = 0;
		for (var i = 0; i < methodText.length; i++) {
			switch (methodText.charAt(i)) {
				case '(':
					roundCount++;
					break;
				case ')':
					roundCount--;
					break;
				case '[':
					squareCount++;
					break;
				case ']':
					squareCount--;
					break;
				default:
			}
			if (squareCount == -1 || roundCount == -1) {
				return false;
			}
		}
		return (squareCount == 0 && roundCount == 0);
	}

	//returns the methodtext of the method the line is in
	getMethodText(editorText, line): string {
		line = line - 1;
		var editorLines = editorText.split("\n");
		var startLine = 0;
		var endLine = editorLines.length - 1;

		for (var i = line - 1; i >= 0; i--) {
			if (editorLines[i].startsWith("to")) {
				startLine = i;
				break;
			}
		}

		for (var j = line; j < editorLines.length; j++) {
			if (editorLines[j].startsWith("end") || editorLines[j].startsWith("to ")) {
				endLine = j;
				break;
			}
		}

		if (startLine == -1) {
			startLine = 0;
		}

		var methodText = "";
		for (var k = startLine; k <= endLine; k++) {
			methodText = methodText + "\n" + editorLines[k];
		}

		return methodText;
	}

	handleError(e, content): string {
		let extraneous;
		let l = this.lang.getLang();

		var temp = 1;
		// analyze input and change error message in history accordingly
		if (e.msg == null) {
			//some weird error occurred
			e.msg = "ERROR";
		} else if (e.msg.indexOf("\'to\'") !== -1) {
			// missing TO
			e.msg = l['missingTo'];
		} else if (e.msg.startsWith('extraneous')) {
			// too many parameters
			extraneous = content.slice(e.start, content.length);
			extraneous = extraneous.split(/[\s,]+/)[0];

			let squareBracketsOkay = this.checkSquareBracketNumber(extraneous);
			let roundBracketsOkay = this.checkRoundBracketNumber(extraneous);

			if (squareBracketsOkay) {
				//there is a problem with the square brackets
				//e.msg = l['squareBracketProblem'];
				if (this.bracketsInMethodOkay(this.getMethodText(content, e.line))) {
					extraneous = this.extractExtraneous(extraneous);
					e.msg = l['extraneousInput'] + extraneous;
				} else {
					e.msg = l['bracketError'];
				}
			} else if (roundBracketsOkay) {
				//e.msg = l['roundBracketProblem'];
				if (this.bracketsInMethodOkay(this.getMethodText(content, e.line))) {

					extraneous = this.extractExtraneous(extraneous);
					e.msg = l['extraneousInput'] + extraneous;
				} else {
					e.msg = l['bracketError'];
				}
			} else {
				e.msg = l['extraneousInput'] + extraneous;
			}

			let temp = extraneous.split("\\n").length;
			if (temp > 1) {
				let additionalLines = temp - 1;
				e.line = e.line - additionalLines;
			}
		} else if (e.msg.startsWith("no viable alternative at input \'to\\")) {
			// no such method available
			e.msg = l['noMethodName'];
		} else if (e.msg.startsWith('no viable')) {
			// too few paramteres

			extraneous = e.msg;
			extraneous = extraneous.split("'");
			extraneous = extraneous[extraneous.length - 2];

			let squareBracketsOkay = this.checkSquareBracketNumber(extraneous);
			let roundBracketsOkay = this.checkRoundBracketNumber(extraneous);

			if (squareBracketsOkay) {
				//there is a problem with the square brackets
				//e.msg = l['squareBracketProblem'];
				if (this.checkSquareBracketNumber(extraneous)) {
					//there is a problem with the square brackets
					//e.msg = l['squareBracketProblem'];
					if (this.bracketsInMethodOkay(this.getMethodText(content, e.line))) {
						extraneous = this.extractExtraneous(extraneous);
						e.msg = l['extraneousInput'] + extraneous;
					} else {
						e.msg = l['bracketError'];
					}
				}
			} else if (roundBracketsOkay) {
				//e.msg = l['roundBracketProblem'];
				if (this.bracketsInMethodOkay(this.getMethodText(content, e.line))) {
					extraneous = this.extractExtraneous(extraneous);
					e.msg = l['extraneousInput'] + extraneous;
				} else {
					e.msg = l['bracketError'];
				}
			} else {
				e.msg = l['extraneousInput'];// + extraneous;
			}
			let temp = extraneous.split('\\n').length;
			if (temp > 1) {
				let additionalLines = temp - 1;
				e.line = e.line - additionalLines;
			}
		} else if (e.msg.startsWith('colornameMisspelled')) {
			// the color name was misspelled
			if (e.msg === "colornameMisspelled") {
				// there was no similar color name found
				e.msg = l['colornameMisspelled'];
			} else {
				// there was a similar color name found
				let similarColor = e.msg.substr(19);
				e.msg = l['colornameMisspelled'] + l['didYouMean'] + similarColor;
			}
		} else if (e.msg.startsWith("didYouMean")) {
			let didYouMean = e.msg.substr(10);
			e.msg = l['didYouMean'] + didYouMean;
		} else if (e.msg.startsWith("funcMisspelled")) {
			let misspelled = e.msg.substr(14);
			e.msg = misspelled + l['funcMisspelled'];
		} else if (e.msg.startsWith('variableNotDeclared')) {
			// the variable we are trying to access was not declared
			let variableName = e.msg.substr(19);
			e.msg = l['variableNotDeclared'] + variableName;
		} else if (e.msg.startsWith('sameParam')) {
			// a parameter was declared several times in the procedure declaration
			let parameterName = e.msg.substr(9);
			e.msg = l['sameParam'] + parameterName;
		} else if (e.msg.startsWith('noColorWithThisName')) {
			// the color name doesn't exist
			let colorName = e.msg.substr(19);
			e.msg = l['noColorWithThisName'] + colorName;
		} else if (e.msg.startsWith('tooMuch')) {
			// there were too many arguments
			let tooMuch = e.msg.substr(7);
			e.msg = l['tooMuch'] + tooMuch;
		} else if (!(e.msg.indexOf("mismatched") === -1)) {
			// mismatched input error, TODO
			e.msg = "ERROR";
		} else {
			e.msg = l[e.msg];
		}

		return e.msg;
	}

}



// WEBPACK FOOTER //
// ./src/app/components/input.component.ts